<template>
  <div class="top flex justify-between">
    <img
      src="@/assets/images/google.png"
      class="google-img" />
    <img
      src="@/assets/images/top.png"
      class="top-img" />
  </div>
</template>
<style lang="scss" scoped>
.top {
  padding: 20px 0 25px 0;
  img {
    object-fit: contain;
  }
  .google-img {
    width: 97px;
  }
  .top-img {
    width: 68px;
  }
}
</style>
